// import * as React, from "react";
import React, { useEffect, useState } from "react";

// React Bootstrap
import { Modal, Tab, Nav, Offcanvas } from 'react-bootstrap';
import { fiatDepositDetails, config } from '../config.js';
import Whitelist from './whiteListAccounts/whiteList.js';
import TablePagination from "../components/TablePagination.js";





// Import Components
import Header from "../components/HeaderComponent";
import SelectDropdown from "../components/SelectDropdown";
import CoinSelectDropdown from "../components/CoinSelectDropdown";
import { Link } from "react-router-dom";

// Import Images
import managingImage from '../assets/images/manage-crypto-img.svg'
import bitcoinImage from '../assets/images/bitcoin-logo.svg'
import etheriumImage from '../assets/images/etherium-logo.svg'
import qrcodeImage from '../assets/images/qrcode-img.png'
import whiteLogo from '../assets/images/logo-white.svg'
import usdLogo from '../assets/images/usdt-logo.png'
import euroLogo from '../assets/images/euro-logo.svg'

// Import Icons
import plusIcon from '../assets/images/icons/plus-white-icon.svg'
import searchIcon from '../assets/images/icons/search-gray-icon.svg'
import arrowDownIcon from '../assets/images/icons/arrow-angle-down-small-icon.svg'
import crossIcon from '../assets/images/icons/cross-gray-icon.svg'
import walletIcon from '../assets/images/icons/wallet-gray-icon.svg'
import walletDarkIcon from '../assets/images/icons/wallet-dark-gray-icon.svg'
import usdcIcon from '../assets/images/icons/usdc-coin-icon.png'
import btcTagIcon from '../assets/images/icons/btc-tag-icon.svg'
import bankIcon from '../assets/images/icons/back-icon.svg'
import uploadFileIcon from '../assets/images/icons/upload-file-icon.svg'



function HomePage() {
    const [createWallet, setCreateWallet] = useState(false);

    const [withdrawShow, setWithdraw] = useState(false);

    const [assetsDepositWalletShow, setAssetsDepositWallet] = useState(false);
    const [walletsDepositWalletShow, setWalletsDepositWallet] = useState(false);
    const [fiatDepositShow, setFiatDepositShow] = useState(false);
    const [uploadProofShow, setUploadProofShow] = useState(false);
    const [assetsWithdrawShow, setAssetsWithdrawShow] = useState(false);
    const [assetsWithdrawFundsShow, setAssetsWithdrawFundsShow] = useState(false);
    const [selectedWithdrawCurrency, setSelectedWithdrawCurrency] = useState([]);
    const [addWhitelistWalletShow, setAddWhitelistWallet] = useState(false);
    const [selectedCurrencyWallet, setSelectedCurrencyWallet] = useState({});

    // Mobile popup States
    const [walletsDepositWalletMobileShow, setWalletsDepositWalletMobile] = useState(false);
    const [fiatDepositMobileShow, setFiatDepositMobileShow] = useState(false);
    const [uploadProofMobileShow, setUploadProofMobileShow] = useState(false);
    const [uploadFiatFile, setUploadFiatFile] = useState(false);
    const [assetsDepositWalletMobileShow, setAssetsDepositWalletMobile] = useState(false);
    const [selectedDepositeCurrency, setSelectedDepositeCurrency] = useState({});
    const [assetsWithdrawMobileShow, setAssetsWithdrawMobileShow] = useState(false);
    const [assetsWithdrawFundsMobileShow, setAssetsWithdrawFundsMobileShow] = useState(false);
    const [UserCurrencyResponse, setUserCurrencyResponse] = useState([]);
    const [createWalletValidation, setCreateWalletValidation] = useState(false);
    const [deafultCurrency, setDeafultCurrency] = useState([]);
    const [amount, setAmount] = useState(0);
    const [error, setError] = useState('');
    const [withdrawaaddress, setWithdrawaaddress] = useState('');
    const [selectedDepositBank, setSelectedDepositBank] = useState(false);
    const [depositFiatCurrency, setDepositFiatCurrency] = useState(false);
    const [selectedFaitFromSourceAccount, setSelectedFaitFromSourceAccount] = useState(false);
    const [selectedFaitAmount, setSelectedFaitAmount] = useState(false);
    const [fiatValidation, setFiatValidation] = useState(false);
    const [cryptoCurrencyListdata, setCryptoCurrencyListdata] = useState(false);
    const [cryptoCurrencyInfo, setCryptoCurrencyInfo] = useState(false);
    const [cryptoCurrencyExchangeRate, setCryptoCurrencyExchangeRate] = useState(false);
    const [userWiseWhiteList, setUserWiseWhiteList] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [whiteListCurrentPage, setWhiteListCurrentPage] = useState(1);;
    const [whiteListLimit, setWhiteListLimit] = useState(20);
    const [whiteListCount, setWhiteListCount] = useState(0);


    // Slider Code Start
    const assetSlider = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 3.5,
        slidesToScroll: 3.5,
        autoplaySpeed: 2000,
        autoplay: false,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 2.3,
                    slidesToScroll: 1,
                    initialSlide: 1
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2.4,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 4.4,
                    slidesToScroll: 1,
                    initialSlide: 1
                }
            },

            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2.4,
                    slidesToScroll: 1
                }
            }
        ]
    };
    // Slider Code Start



    // Custom Select Wallet Start
    const selectWalletOptions = [
        { label: "John’s BTC Wallet", icon: walletIcon },
        { label: "Owais BTC Wallet", icon: walletIcon },
        { label: "Raj BTC Wallet", icon: walletIcon },
    ];

    const onSelectWallet = (value) => {
        // console.log("Selected Value:", value);
    };
    // Custom Select Wallet End



    // Custom Select Coin Start
    const selectCoinOptions = [
        { label: "Bitcoin", shortName: "BTC", icon: bitcoinImage },
        { label: "Etherium", shortName: "ETH", icon: etheriumImage },
    ];
    const onSelectCoin = (value) => {
        // console.log("Selected Value:", value);
    };
    // Custom Select Coin End


    // Add Whitelist Wallet Select Coin Start
    // const selectAddWhitelistWalletOptions = [
    //     { label: "Bitcoin", shortName: "BTC", icon: bitcoinImage },
    //     { label: "Etherium", shortName: "ETH", icon: etheriumImage },
    //     { label: "USD", shortName: "USD", icon: usdLogo },
    //     { label: "EURO", shortName: "EURO", icon: euroLogo },
    // ];
    // const onSelectAddWhitelistWallet = (value) => {
    //     console.log({ value })
    //     if (value.type == 'C') {
    //         setWhitelistCoinSelect('crypto');
    //     } else {
    //         setWhitelistCoinSelect('fiat');
    //     }
    // };




    // Add Whitelist Wallet Select Coin End



    // Custom Select Coin Start
    const selectWalletCoinOptions = userWiseWhiteList
        .map((item, index) => {
            if (item.type === 'C') {
                return {
                    label: item.walletname,
                    address: item.walletaddress,
                    currencycode: item.currencycode,
                    icon: walletIcon
                };
            } else {
                return null;
            }
        })
        .filter(item => item !== null);


    const onSelectWalletCoin = (value) => {
        console.log("Selected Value:", value);
    };
    // Custom Select Coin End




    // Custom Select Wallet Start
    const selectBanksOptions = userWiseWhiteList
        .map((item, index) => {
            if (item.type === 'F') {
                return { label: `${item.bankaccountnumber} - ${item.bankname}`, account: item.bankaccountnumber, icon: bankIcon };
            } else {
                return null;
            }
        })
        .filter(item => item !== null);
    ;

    const onSelectBanksandWallet = (value) => {
        if (value.address != undefined) {
            setWithdrawaaddress(value.address);
        } else {


            setWithdrawaaddress(value.account);
        }
    };
    // Custom Select Wallet End









    // Withdraw Modal Start
    const onWithdrawClose = () => setWithdraw(false);
    const onWithdrawShow = () => setWithdraw(true);
    // Withdraw Modal End




    // Assets Deposit Wallet Modal Start
    const onAssetsDepositWalletClose = () => setAssetsDepositWallet(false);
    const onAssetsDepositWalletShow = (res) => { setSelectedDepositeCurrency(res); setAssetsDepositWallet(true) };
    // Assets Deposit Wallet Modal End

    // Assets Deposit Wallet Mobile Modal Start
    const onAssetsDepositWalletMobileClose = () => setAssetsDepositWalletMobile(false);
    const onAssetsDepositWalletMobileShow = () => setAssetsDepositWalletMobile(true);
    // Assets Deposit Wallet Mobile Modal End




    // Assets Deposit Wallet Modal Start
    const onWalletsDepositWalletClose = () => setWalletsDepositWallet(false);
    const onWalletsDepositWalletShow = () => setWalletsDepositWallet(true);
    // Assets Deposit Wallet Modal End

    // Assets Deposit Wallet Mobile Modal Start
    const onWalletsDepositWalletMobileClose = () => setWalletsDepositWalletMobile(false);
    const onWalletsDepositWalletMobileShow = () => setWalletsDepositWalletMobile(true);
    // Assets Deposit Wallet Modal Mobile End




    // Fiat Deposit Modal Start
    const onFiatDepositClose = () => {
        setFiatDepositShow(false);
    }
    const onFiatDepositShow = (res) => {
        setDepositFiatCurrency(res)
        setFiatDepositShow(true);
        setWalletsDepositWallet(false);
    }
    // Fiat Deposit Modal End


    // Fiat Deposit Mobile Modal Start
    const onFiatDepositMobileClose = () => {
        setFiatDepositMobileShow(false);
    }
    const onFiatDepositMobileShow = () => {
        setFiatDepositMobileShow(true);
        setWalletsDepositWalletMobile(false);
    }
    // Fiat Deposit Modal Mobile End





    // Fiat Deposit Modal Start
    const onUploadProofClose = () => {
        setUploadProofShow(false);
    }
    const onUploadProofShow = () => {
        setUploadProofShow(true);
        setFiatDepositShow(false);
    }
    // Fiat Deposit Modal End

    // Fiat Deposit Mobile Modal Start
    const onUploadProofMobileClose = () => {
        setUploadProofMobileShow(false);
    }
    const onUploadProofMobileShow = () => {
        setUploadProofMobileShow(true);
        setFiatDepositMobileShow(false);
    }
    // Fiat Deposit Mobile Modal End




    // Assets Withdraw Modal Start
    const onAssetsWithdrawClose = () => {
        setAssetsWithdrawShow(false);
    }
    const onAssetsWithdrawShow = () => {
        setAssetsWithdrawShow(true);
    }
    // Assets Withdraw Modal End

    // Assets Withdraw Mobile Modal Start
    const onAssetsWithdrawMobileClose = () => {
        setAssetsWithdrawMobileShow(false);
    }
    const onAssetsWithdrawMobileShow = () => {
        setAssetsWithdrawMobileShow(true);
    }
    // Assets Withdraw Mobile Modal End




    // Assets Withdraw Modal Start
    const onAssetsWithdrawFundsClose = () => {
        setAssetsWithdrawFundsShow(false);
    }
    const onAssetsWithdrawFundsShow = (res) => {
        setWithdrawaaddress(false)
        setSelectedWithdrawCurrency(res);
        setAssetsWithdrawFundsShow(true);
        setAssetsWithdrawShow(false);
    }
    // Assets Withdraw Modal End

    // Assets Withdraw Mobile Modal Start
    const onAssetsWithdrawFundsMobileClose = () => {
        setAssetsWithdrawFundsMobileShow(false);
    }
    const onAssetsWithdrawFundsMobileShow = () => {
        setAssetsWithdrawFundsMobileShow(true);
        setAssetsWithdrawMobileShow(false);
    }
    // Assets Withdraw Mobile Modal End


    // Add Whitelist Wallet Modal Start
    const onAddWhitelistWalletClose = () => {
        setAddWhitelistWallet(false);
    }
    const onAddWhitelistWalletShow = () => {
        setAddWhitelistWallet(true);
    }
    // Add Whitelist Wallet Modal End



    // Custom Code Start
    const [wallets, setWallets] = useState([
        { id: 1, name: "John’s BTC Wallet" },
        { id: 2, name: "Raj ETH Wallet" },
        { id: 2, name: "Aries ETH Wallet" },
        { id: 2, name: "Owais BTC Wallet" },
        { id: 2, name: "Bimla ETH Wallet" },
    ]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showQRCode, setShowQRCode] = useState(false);

    // Filtered wallets based on search query
    const filteredWallets = wallets.filter(wallet => {
        try {
            wallet.name.toLowerCase().includes(searchQuery.toLowerCase())
        }
        catch (err) {
            console.log(err)
        }
    }
    );
    const onCreateWallet = () => {
        setCreateWallet(true);

    }
    const onCreateWalletclose = () => {
        setCreateWallet(false);
    }
    // Custom Code End


    // Otp Code
    // const [otp, setOtp] = useState("");
    // const handleOtpChange = (e) => {
    //     const value = e.target.value.replace(/\D/g, ""); // Allow only digits
    //     if (value.length <= 4) {
    //         setOtp(value);
    //     }
    // };


    useEffect(() => {
        hendelusercurrencyres();
        handelwhitelistwallet(whiteListCurrentPage);
        handeldeafultcurrency();

    }, []
    )
    async function hendelgocutokenurls(usercurrency) {
        try {
            let cryptoCurrencyList;
            let cryptoCurrencyData
            let cryptoCurrencyPriceExchange;
            if (!cryptoCurrencyListdata) {
                // console.log("yes")
                cryptoCurrencyList = await fetch('https://api.coingecko.com/api/v3/coins/list', { method: 'GET', headers: { "x-cg-demo-api-key": "CG-pHUKYoqXkuRdQ4ibpdPv5Nk2" } });
                cryptoCurrencyList = await cryptoCurrencyList.json();
                // console.log({ cryptoCurrencyList, usercurrency })
                if (usercurrency) {
                    cryptoCurrencyList = cryptoCurrencyList.filter(res => {
                        return usercurrency.some(result => {
                            return (res.symbol).toLowerCase() == (result.currencycode).toLowerCase() && (res.name).toLowerCase() == (result.currencyname).toLowerCase()
                        }
                        );
                    });
                    // console.log({ cryptoCurrencyList1: cryptoCurrencyList })
                    setCryptoCurrencyListdata(cryptoCurrencyList)
                }

            }
        } catch (err) {
            console.log(err);
        }
        // if (!cryptoCurrencyListdata && !cryptoCurrencyInfo) {
        //     cryptoCurrencyPriceExchange = fetch('https://api.coingecko.com/api/v3/simple/supported_vs_currencies', { method: 'get', headers: { "x-cg-demo-api-key": "CG-pHUKYoqXkuRdQ4ibpdPv5Nk2" } });

        //     setCryptoCurrencyInfo(currencysupportcode);
        // }

    }
    useEffect(() => {
        // Create an async function inside the effect
        const fetchCryptoData = async () => {
            if (!cryptoCurrencyListdata?.length) return;

            try {
                // Use Promise.all to wait for all fetch requests to complete
                const cryptoCurrencyData = await Promise.all(
                    cryptoCurrencyListdata.map(async (res) => {
                        const response = await fetch(
                            `https://api.coingecko.com/api/v3/coins/${res.id}`,
                            {
                                method: 'GET',
                                headers: { "x-cg-demo-api-key": "CG-pHUKYoqXkuRdQ4ibpdPv5Nk2" }
                            }
                        );
                        return await response.json();
                    })
                );

                // console.log("Fetched crypto data:", cryptoCurrencyData);
                setCryptoCurrencyInfo(cryptoCurrencyData);
            } catch (error) {
                console.error("Error fetching crypto data:", error);
                // Handle error appropriately
            }
        };

        fetchCryptoData();
    }, [cryptoCurrencyListdata]);

    useEffect(() => {
        if (selectedWithdrawCurrency !== undefined) {
            if (selectedWithdrawCurrency.type === 'C') {
                setError(selectWalletCoinOptions.length === 0
                    ? 'First whitelist any one address of your wallet and try again later.'
                    : false
                );
            } else {
                setError(selectBanksOptions.length === 0
                    ? 'First whitelist any one of account your bank and try again later.'
                    : false
                );
            }
        }
    }, [selectedWithdrawCurrency, selectWalletCoinOptions.length, selectBanksOptions.length]);

    useEffect(() => {
        // Create an async function inside the effect
        const fetchCryptoData = async () => {
            if (!cryptoCurrencyListdata?.length) return;

            try {
                // Use Promise.all to wait for all fetch requests to complete
                let requestCurrencyCode = cryptoCurrencyListdata.map(res => res.id);

                let response = await fetch(
                    `https://api.coingecko.com/api/v3/simple/price?ids=bitcoin,${requestCurrencyCode.toString()}&vs_currencies=usd,eur`,
                    {
                        method: 'GET',
                        headers: { "x-cg-demo-api-key": "CG-pHUKYoqXkuRdQ4ibpdPv5Nk2" }
                    })

                response = await response.json();
                let currencyCodeResponse = {};
                Object.keys(response).forEach(res => {
                    const matchedCurrency = cryptoCurrencyListdata.find(result => result.id === res);
                    if (matchedCurrency) {
                        currencyCodeResponse[matchedCurrency.symbol] = response[res];
                    }
                    else {
                        currencyCodeResponse[res] = response[res]
                    }
                });
                // console.log("Fetched crypto data:", currencyCodeResponse);
                setCryptoCurrencyExchangeRate(currencyCodeResponse);
            } catch (error) {
                console.error("Error fetching crypto data:", error.stack);
                // Handle error appropriately
            }
        };

        fetchCryptoData();
    }, [cryptoCurrencyInfo]);
    // const handleOtpPaste = (e) => {
    //     e.preventDefault();
    //     const pasteData = e.clipboardData.getData("Text").replace(/\D/g, ""); // Extract digits from pasted data
    //     if (pasteData.length === 4) {
    //         setOtp(pasteData);
    //     }
    // };
    let sessionvalue = sessionStorage.getItem("logedinUser");
    async function hendelusercurrencyres() {
        try {
            if (sessionvalue) {
                let usercurrencydata = await fetch(config.API_BASE_URL + '/getuserwisecurrency', { method: 'POST', body: sessionvalue });
                let res = await usercurrencydata.json();

                // console.log(res.data);
                hendelgocutokenurls(res.data);
                setUserCurrencyResponse(res.data);
            }
        }
        catch (err) {
            console.log(err);
        }
    }
    async function onSelectDeafultCurrency(e) {
        try {
            let flag = 1;
            // First, check if the currency code exists in the array
            const matchingCurrency = UserCurrencyResponse.find(res => res.currencycode === e.code);

            if (matchingCurrency) {
                setCreateWalletValidation(true);
                flag = 0;
            } else {
                setCreateWalletValidation(false);
                setSelectedCurrencyWallet(e);
            }
            if (flag) setCreateWalletValidation(false); setSelectedCurrencyWallet(e);
        } catch (err) {
            console.log(err);
        }
    }

    async function handelcreatewallet() {


        try {
            let request = `{"email":"${(JSON.parse(sessionvalue)).email}","insert":true,"defualtCurrencyquery":{"currencycode":"${selectedCurrencyWallet.currencycode}","currencyimage":"${selectedCurrencyWallet.currencyimage}"}}`;
            let userwisecurrencyinsert = await fetch(config.API_BASE_URL + '/updateuserwisecurrency', { method: 'POST', body: request })
            window.location.href = '/home-page';
            // console.log({ userwisecurrencyinsert });
        }
        catch (err) {
            console.log(err);
        }
    }

    async function handeldeafultcurrency() {
        try {
            if (sessionvalue) {
                let deafultCurrency = await fetch(config.API_BASE_URL + '/defaultcurrencyget', { method: 'POST', body: '{}' });
                let res = await deafultCurrency.json();

                const missingCurrencies = res.data.filter(item =>
                    !UserCurrencyResponse.some(userCurrency =>
                        userCurrency.currencycode === item.currencycode
                    )
                );
                setDeafultCurrency(missingCurrencies);
            }
        }
        catch (err) {
            console.log(err);
        }
    }

    function handelInput(e, amount) {
        if (selectedWithdrawCurrency !== undefined) {
            if (selectedWithdrawCurrency.type === 'C') {
                console.log({ selectWalletCoinOptions })
                setError(selectWalletCoinOptions.length === 0
                    ? 'First whitelist any one address of your wallet and try again later.'
                    : false
                );
            } else {
                setError(selectBanksOptions.length === 0
                    ? 'First whitelist any one of account your bank and try again later.'
                    : false
                );
            }
        }

        if (error != false) return;
        if (amount < e.target.value) {
            setError('Please Enter less then avilable blance')
        } else if (amount == 0) {
            setError('first insert amount in your currency!!')

        } else {
            setError(false)
            setAmount(e.target.value)

        }

    }

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };
    const filteredAssets = UserCurrencyResponse.filter((res) => { try { return res.currencyname.toLowerCase().includes(searchQuery.toLowerCase()) || res.currencycode.toLowerCase().includes(searchQuery.toLowerCase()) } catch (err) { console.log(res, err); return []; } }

    );
    async function selectedWithdrawsubmit(selectedWithdrawCurrency) {
        if (window.confirm("Are you sure to withdraw?")) {
            // console.log(withdrawaaddress);
            if (!withdrawaaddress) {
                setError('Please Enter Valide Value!!!')
                return;
            }
            setError(false);
            let request = `{
    "email": "${(JSON.parse(sessionvalue)).email}",
        "currencycode": "${selectedWithdrawCurrency.currencycode}",
        "currencyname": "${selectedWithdrawCurrency.currencyname}",
        "priceamount": ${amount},
        "fromaddress": "-",
        "toaddress": "${withdrawaaddress}",
        "status": "Pending",
        "type": "${selectedWithdrawCurrency.type}",
        "transactiontype":"DEBITED"

    }`
            let usercurrencywithdrawdata = await fetch(config.API_BASE_URL + '/updateinserttransectionhistory', { method: 'POST', body: request });
            let res = await usercurrencywithdrawdata.json();
            window.location.href = '/home-page'
        }
        // console.log(res)
    }
    async function handelwhitelistwallet(currentpage) {
        try {
            if (sessionvalue) {
                let skip = (currentpage - 1) * whiteListLimit;
                let request = `{
                "email": "${(JSON.parse(sessionvalue)).email}",
                "query":{"status":"Completed"},
                    "skip": ${skip},
                    "limit": ${whiteListLimit}
            
                }`;

                let usercurrencywhitelistdata = await fetch(config.API_BASE_URL + '/getWhiteListAccount', { method: 'POST', body: request });
                let res = await usercurrencywhitelistdata.json();
                // console.log({ res })
                setUserWiseWhiteList(res.data.whitelistdatadetails);
                setWhiteListCount(res.data.whitelistCount);
            }
        } catch (err) {
            console.log(err);
        }
    }
    async function hanselDepositFiatCurrency() {

        if (!selectedFaitFromSourceAccount && selectedFaitFromSourceAccount == '') {
            setFiatValidation("source Account can not blank!!!");
            return;
        }

        if (!selectedFaitAmount && selectedFaitAmount == '') {
            setFiatValidation("Amount can not blank!!!");
            return;
        }

        if (uploadFiatFile) {
            let FiatFile = uploadFiatFile.target.files[0];
            // PDF validation
            if (FiatFile.type !== 'application/pdf') {
                setFiatValidation('Only PDF documents are allowed');
                setUploadFiatFile(false);
                return;
            }
        }

        if (window.confirm("Are you sure for deposit currency ??")) {
            let file = uploadFiatFile ? uploadFiatFile.target.files[0] : false;
            const arrayBuffer = await file.arrayBuffer();
            const bytes = new Uint8Array(arrayBuffer);

            // Convert to Base64 without Buffer (browser-compatible)
            let binary = '';
            bytes.forEach(byte => binary += String.fromCharCode(byte));
            let fileBase64 = btoa(binary);

            let request = `{
            "email": "${(JSON.parse(sessionvalue)).email}",
                "currencycode": "${depositFiatCurrency.currencycode}",
                "currencyname": "${depositFiatCurrency.currencyname}",
                "priceamount": ${selectedFaitAmount},
                "fromaddress": "${selectedFaitFromSourceAccount}",
                "toaddress": "${selectedDepositBank.BankDetails["Account No"]}",
                "filename":"${uploadFiatFile ? file.name : 'false'}",
                "file":${JSON.stringify(fileBase64) || 'false'},
                "status": "Pending",
                "type": "F",
                "transactiontype":"CREDITED"
        
            }`
            console.log({ request })
            let usercurrencywithdrawdata = await fetch(config.API_BASE_URL + '/updateinserttransectionhistory', { method: 'POST', body: request });
            await usercurrencywithdrawdata.json();
            setUploadFiatFile(false);
            window.location.href = "/home-page"
        }

    }
    function handelSelectedDepositBank(bank) {
        try {
            if (bank.BankDetails["Account No"] !== selectedDepositBank?.BankDetails?.["Account No"]) {
                setSelectedFaitFromSourceAccount(false);
                setSelectedFaitAmount(false);
                setSelectedDepositBank(bank)

            }
        }
        catch (err) {
            console.log({ err })
        }
    }


    const filteredWhiteList = userWiseWhiteList.filter((res) => {
        const term = searchTerm.toLowerCase();
        // handelwhitelistwallet(1);
        return (
            res.walletname?.toLowerCase().includes(term) ||
            res.bankname?.toLowerCase().includes(term) ||
            res.currencycode?.toLowerCase().includes(term)
        );
    });
    return (
        <div className='home-page'>

            <Header />
            <section className="sec-banner">
                <div className="container-fluid">
                    <div className="banner-wrapper">
                        <div className="top-notch-wrapper">
                            <span className="top-notch"></span>
                            <a href="#" className="logo">
                                <img src={whiteLogo} alt="logo" />
                            </a>
                        </div>
                        <div className="container">
                            {/* {(!createWallet) && */}
                            <div className="crypto-card">
                                <div className="content-wrapper">
                                    <h1>Start Managing Your Crypto Securely</h1>
                                    <h3 className="h-font f-17 w-500">Create or link a wallet to access secure custody, transactions, and monitoring. Your crypto journey starts here. Click on Login and start your crypto journey</h3>
                                    {sessionvalue &&
                                        <ul className="btn-list">
                                            <li>
                                                {/*<a href="#" className="btn-style icon" onClick={onCreateWallet}>*/}
                                                <a className="btn-style icon" onClick={() => { onCreateWallet(); handeldeafultcurrency(); }}><img src={plusIcon} alt="icon" /> Create Wallet</a>
                                            </li>
                                            <li>
                                                <Link to="/otc-trade" className="btn-style icon">OTC Trade</Link>
                                            </li>
                                            <li>
                                                <Link to="/transaction-history" className="btn-style icon">Transaction History</Link>
                                            </li>
                                        </ul>
                                    }
                                </div>
                                <div className="img-wrapper">
                                    <img src={managingImage} alt="img" />
                                </div>
                            </div>
                            {/* } */}
                            {/* {(createWallet) &&
                                <div className="row">
                                    <div className="col-lg-6 col-md-12">
                                        <div className="value-asset-card">
                                            <div className="row">
                                                <div className="col-xl-4 col-lg-5 col-md-4 align-self-end">
                                                    <div className="content-wrapper">
                                                        <h3 className="f-24 h-font">Total Value of <br />
                                                            your Assets</h3>
                                                        <strong>$ 23,493</strong>
                                                    </div>
                                                </div>
                                                <div className="col-xl-8 col-lg-7 col-md-8 align-self-end">
                                                    <div className="chart-wrapper">
                                                        <LineChart />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-12">
                                        <div className="your-asset-card">
                                            <h3 className="f-20">Your Assets</h3>
                                            <div className="asset-slider">
                                                <Slider {...assetSlider}>
                                                    <div className="your-asset-card">
                                                        <div className="icon">
                                                            <img src={btcGrayIcon} alt="icon" />
                                                        </div>
                                                        <div className="content">
                                                            <h3 className="h-font f-24 title">1.34 BTC</h3>
                                                            <h3 className="h-font f-20">$2838.3</h3>
                                                        </div>
                                                    </div>
                                                    <div className="your-asset-card">
                                                        <div className="icon">
                                                            <img src={btcGrayIcon} alt="icon" />
                                                        </div>
                                                        <div className="content">
                                                            <h3 className="h-font f-24 title">1.34 BTC</h3>
                                                            <h3 className="h-font f-20">$2838.3</h3>
                                                        </div>
                                                    </div>
                                                    <div className="your-asset-card">
                                                        <div className="icon">
                                                            <img src={btcGrayIcon} alt="icon" />
                                                        </div>
                                                        <div className="content">
                                                            <h3 className="h-font f-24 title">1.34 BTC</h3>
                                                            <h3 className="h-font f-20">$2838.3</h3>
                                                        </div>
                                                    </div>

                                                    <div className="your-asset-card">
                                                        <div className="icon">
                                                            <img src={btcGrayIcon} alt="icon" />
                                                        </div>
                                                        <div className="content">
                                                            <h3 className="h-font f-24 title">1.34 BTC</h3>
                                                            <h3 className="h-font f-20">$2838.3</h3>
                                                        </div>
                                                    </div>
                                                    <div className="your-asset-card">
                                                        <div className="icon">
                                                            <img src={btcGrayIcon} alt="icon" />
                                                        </div>
                                                        <div className="content">
                                                            <h3 className="h-font f-24 title">1.34 BTC</h3>
                                                            <h3 className="h-font f-20">$2838.3</h3>
                                                        </div>
                                                    </div>
                                                    <div className="your-asset-card">
                                                        <div className="icon">
                                                            <img src={btcGrayIcon} alt="icon" />
                                                        </div>
                                                        <div className="content">
                                                            <h3 className="h-font f-24 title">1.34 BTC</h3>
                                                            <h3 className="h-font f-20">$2838.3</h3>
                                                        </div>
                                                    </div>

                                                    <div className="your-asset-card">
                                                        <div className="icon">
                                                            <img src={btcGrayIcon} alt="icon" />
                                                        </div>
                                                        <div className="content">
                                                            <h3 className="h-font f-24 title">1.34 BTC</h3>
                                                            <h3 className="h-font f-20">$2838.3</h3>
                                                        </div>
                                                    </div>
                                                    <div className="your-asset-card">
                                                        <div className="icon">
                                                            <img src={btcGrayIcon} alt="icon" />
                                                        </div>
                                                        <div className="content">
                                                            <h3 className="h-font f-24 title">1.34 BTC</h3>
                                                            <h3 className="h-font f-20">$2838.3</h3>
                                                        </div>
                                                    </div>
                                                    <div className="your-asset-card">
                                                        <div className="icon">
                                                            <img src={btcGrayIcon} alt="icon" />
                                                        </div>
                                                        <div className="content">
                                                            <h3 className="h-font f-24 title">1.34 BTC</h3>
                                                            <h3 className="h-font f-20">$2838.3</h3>
                                                        </div>
                                                    </div>
                                                </Slider>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            } */}
                        </div>
                    </div>
                </div>
            </section>
            {sessionvalue && <section className="sec-wallet">
                <div className="container">
                    <div className="wallet-wrapper">
                        <div className="tabs-wrapper">
                            <Tab.Container defaultActiveKey="first">
                                <div className="tabs-header">
                                    <Nav variant="pills">
                                        <Nav.Item>
                                            <Nav.Link eventKey="first"><h3>Assets</h3></Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="second"><h3>Whitelist Wallet</h3></Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </div>
                                <div className="tabs-body">
                                    <Tab.Content>
                                        <Tab.Pane eventKey="first">
                                            <div className="asset-wrapper">
                                                <div className="asset-header">
                                                    <div className="row">
                                                        <div className="col-md-6 col-7 align-self-center">
                                                            <div className="search-wrapper-v1">
                                                                <div className="form">
                                                                    <div className="form-group">
                                                                        <input type="text" className="form-control" onChange={handleSearchChange} value={searchQuery} placeholder="Search By Currency Name" />
                                                                        <img src={searchIcon} className="icon" alt="icon" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 col-5 align-self-center">
                                                            <ul className="btn-list">
                                                                <li><a href="#" className="btn-style m-w-130 transparent">Show All Assets</a></li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="asset-body">
                                                    <div className="asset-list-wrapper">
                                                        <div className="asset-list desktop">
                                                            <div className="table-header grid-6">
                                                                <div className="asset-item">
                                                                    <p>Asset</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p>Balance</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p>BTC</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p>Price<img src={arrowDownIcon} alt="icon" /></p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p>Portfolio %</p>
                                                                </div>
                                                                <div className="asset-item"></div>
                                                            </div>


                                                            {filteredAssets.length > 0 ? (
                                                                filteredAssets.map((res) => (

                                                                    <div className="asset-card grid-6">
                                                                        <div className="asset-item">
                                                                            <div className="name-wrapper">
                                                                                <div className="icon">
                                                                                    <img src={res.type == 'F' ? ((res.currencycode).toLowerCase()) == 'usd' ? usdLogo : euroLogo : res.currencyimage} alt="img" />
                                                                                </div>
                                                                                <div className="content">
                                                                                    <p className="title p">{res.currencycode}</p>
                                                                                    <p>{res.currencycode}</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="asset-item">
                                                                            <p className="  p-h-1 p w-600" title={res.priceamount + ' ' + res.currencycode}>{res.priceamount} {res.currencycode}</p>
                                                                        </div>
                                                                        <div className="asset-item p-1">
                                                                            {(() => {
                                                                                // Calculate the value first
                                                                                let result;
                                                                                let originalText = `${res.priceamount} ${res.currencycode}`;
                                                                                // console.log(cryptoCurrencyExchangeRate, res);
                                                                                if (!cryptoCurrencyExchangeRate || !res.type) {
                                                                                    result = originalText;
                                                                                } else if (res.type === 'C') {
                                                                                    const cryptoRate = cryptoCurrencyExchangeRate?.[res.currencycode.toLowerCase()]?.usd;
                                                                                    const btcRate = cryptoCurrencyExchangeRate?.bitcoin?.usd;
                                                                                    const amount = Number(res.priceamount);
                                                                                    result = cryptoRate && btcRate ? amount * (cryptoRate / btcRate) : 0;
                                                                                    result = result.toFixed(20);

                                                                                } else {
                                                                                    const btcRate = cryptoCurrencyExchangeRate?.bitcoin?.[res.currencycode.toLowerCase()];
                                                                                    result = btcRate ? res.priceamount / btcRate : 0;
                                                                                }

                                                                                // Format the result (e.g., trim trailing zeros for crypto)
                                                                                const formattedResult = result

                                                                                // Tooltip text (shows original + converted value)
                                                                                const tooltipText = `${formattedResult}`;

                                                                                return (
                                                                                    <p className="p p-h-1 w-600" title={tooltipText + ' BTC'}>
                                                                                        {formattedResult}
                                                                                    </p>
                                                                                );
                                                                            })()}
                                                                        </div>
                                                                        <div className="asset-item p-1">
                                                                            {(() => {
                                                                                // Store original text for fallback and tooltip
                                                                                const originalText = `${res.priceamount} ${res.currencycode}`;

                                                                                // Early return if no conversion possible
                                                                                if (!Object.keys(cryptoCurrencyExchangeRate).length || !res?.type) {
                                                                                    return (
                                                                                        <p className="p p-h-1 w-600" title={`No conversion rates available`}>
                                                                                            {originalText}
                                                                                        </p>
                                                                                    );
                                                                                }

                                                                                const currencyKey = res.currencycode.toLowerCase();
                                                                                const price = Number(res.priceamount) || 0;
                                                                                let convertedValue;

                                                                                // Conversion logic
                                                                                if (res.type === 'C') {
                                                                                    const cryptoUsdRate = Number(cryptoCurrencyExchangeRate?.[currencyKey]?.usd) || 0;
                                                                                    convertedValue = price * cryptoUsdRate;
                                                                                } else {
                                                                                    const btcToCurrencyRate = Number(cryptoCurrencyExchangeRate?.bitcoin?.[currencyKey]) || 1;
                                                                                    const btcUsdRate = Number(cryptoCurrencyExchangeRate?.bitcoin?.usd) || 1;
                                                                                    convertedValue = (price / btcToCurrencyRate) * btcUsdRate;
                                                                                }

                                                                                // Formatting
                                                                                const isCrypto = res.type === 'C';
                                                                                const formattedValue = convertedValue;

                                                                                // Tooltip content
                                                                                const tooltipText = `${formattedValue} USD `;

                                                                                return (
                                                                                    <p className="p p-h-1 w-600" title={tooltipText}>
                                                                                        {formattedValue} USD
                                                                                    </p>
                                                                                );
                                                                            })()}
                                                                        </div>
                                                                        {/* <div className="asset-item">
                                                                        <p className="p w-600">{res.priceamount} {res.currencycode}</p>
                                                                    </div> */}
                                                                        <div className="asset-item">
                                                                            <p className="p w-600">
                                                                                {(() => {
                                                                                    if (!cryptoCurrencyExchangeRate || !res.type) return '0%';

                                                                                    // Calculate this asset's USD value
                                                                                    let assetUsdValue;
                                                                                    const currencyKey = res.currencycode.toLowerCase();
                                                                                    const amount = Number(res.priceamount) || 0;

                                                                                    if (res.type === 'C') {
                                                                                        // Crypto: amount * USD rate
                                                                                        const cryptoUsdRate = cryptoCurrencyExchangeRate[currencyKey]?.usd || 0;
                                                                                        assetUsdValue = amount * cryptoUsdRate;
                                                                                    } else {
                                                                                        // Fiat: if USD, use directly, else convert via BTC rates
                                                                                        if (currencyKey === 'usd') {
                                                                                            assetUsdValue = amount;
                                                                                        } else {
                                                                                            // For non-USD fiat, convert to BTC then to USD
                                                                                            const btcToCurrencyRate = cryptoCurrencyExchangeRate.bitcoin?.[currencyKey] || 1;
                                                                                            const btcUsdRate = cryptoCurrencyExchangeRate.bitcoin?.usd || 1;
                                                                                            assetUsdValue = (amount / btcToCurrencyRate) * btcUsdRate;
                                                                                        }
                                                                                    }

                                                                                    // Calculate total portfolio USD value by summing all assets
                                                                                    let totalUsdValue = 0;
                                                                                    filteredAssets.forEach(asset => {
                                                                                        const assetCurrencyKey = asset.currencycode.toLowerCase();
                                                                                        const assetAmount = Number(asset.priceamount) || 0;

                                                                                        if (asset.type === 'C') {
                                                                                            // Crypto asset
                                                                                            const rate = cryptoCurrencyExchangeRate[assetCurrencyKey]?.usd || 0;
                                                                                            totalUsdValue += assetAmount * rate;
                                                                                        } else {
                                                                                            // Fiat asset
                                                                                            if (assetCurrencyKey === 'usd') {
                                                                                                totalUsdValue += assetAmount;
                                                                                            } else {
                                                                                                // Non-USD fiat
                                                                                                const btcToCurr = cryptoCurrencyExchangeRate.bitcoin?.[assetCurrencyKey] || 1;
                                                                                                const btcUsd = cryptoCurrencyExchangeRate.bitcoin?.usd || 1;
                                                                                                totalUsdValue += (assetAmount / btcToCurr) * btcUsd;
                                                                                            }
                                                                                        }
                                                                                    });

                                                                                    // Calculate percentage (ensure we don't divide by zero)
                                                                                    return totalUsdValue > 0
                                                                                        ? `${((assetUsdValue / totalUsdValue) * 100).toFixed(2)}%`
                                                                                        : '0%';
                                                                                })()}
                                                                            </p>
                                                                        </div>
                                                                        <div className="asset-item">
                                                                            <ul className="btn-list">
                                                                                <li><a href="#" className="btn-style h-36 transparent" onClick={(e) => { handelInput(e, res.priceamount); onAssetsWithdrawFundsShow(res) }}>Withdraw</a></li>
                                                                                <li><a href="#" className="btn-style h-36 transparent" onClick={() => res.type == 'C' ? onAssetsDepositWalletShow(res) : onFiatDepositShow(res)}>Deposit</a></li>
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <div>No results found</div>
                                                            )}
                                                            {/* <div className="asset-card grid-5">
                                                                <div className="asset-item">
                                                                    <div className="name-wrapper">
                                                                        <div className="icon">
                                                                            <img src={usdLogo} alt="img" />
                                                                        </div>
                                                                        <div className="content">
                                                                            <p className="title p">USD</p>
                                                                            <p>usd</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p className="p w-600">400 BTC</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p className="p w-600">0.00323 USD</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p className="p w-600">12%</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <ul className="btn-list">
                                                                        <li><a href="#" className="btn-style h-36 transparent" onClick={onAssetsWithdrawFundsShow}>Withdraw</a></li>
                                                                        <li><a href="#" className="btn-style h-36 transparent" onClick={onFiatDepositShow}>Deposit</a></li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                            <div className="asset-card grid-5">
                                                                <div className="asset-item">
                                                                    <div className="name-wrapper">
                                                                        <div className="icon">
                                                                            <img src={euroLogo} alt="img" />
                                                                        </div>
                                                                        <div className="content">
                                                                            <p className="title p">EURO</p>
                                                                            <p>euro</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p className="p w-600">0 BTC</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p className="p w-600">0.00323 USD</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p className="p w-600">12%</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <ul className="btn-list">
                                                                        <li><a href="#" className="btn-style h-36 transparent" onClick={onAssetsWithdrawFundsShow}>Withdraw</a></li>
                                                                        <li><a href="#" className="btn-style h-36 transparent" onClick={onFiatDepositShow}>Deposit</a></li>
                                                                    </ul>
                                                                </div>
                                                            </div>

                                                            <div className="asset-card grid-5">
                                                                <div className="asset-item">
                                                                    <div className="name-wrapper">
                                                                        <div className="icon">
                                                                            <img src={bitcoinImage} alt="img" />
                                                                        </div>
                                                                        <div className="content">
                                                                            <p className="title p">Bitcoin</p>
                                                                            <p>BTC</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p className="p w-600">0 BTC</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p className="p w-600">0.00323 USD</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p className="p w-600">12%</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <ul className="btn-list">
                                                                        <li><a href="#" className="btn-style h-36 transparent" onClick={onAssetsWithdrawShow}>Withdraw</a></li>
                                                                        <li><a href="#" className="btn-style h-36 transparent" onClick={onAssetsDepositWalletShow}>Deposit</a></li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                            <div className="asset-card grid-5">
                                                                <div className="asset-item">
                                                                    <div className="name-wrapper">
                                                                        <div className="icon">
                                                                            <img src={etheriumImage} alt="img" />
                                                                        </div>
                                                                        <div className="content">
                                                                            <p className="title p">Etherium</p>
                                                                            <p>ETH</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p className="p w-600">0 BTC</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p className="p w-600">0.00323 USD</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p className="p w-600">12%</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <ul className="btn-list">
                                                                        <li><a href="#" className="btn-style h-36 transparent" onClick={onAssetsWithdrawShow}>Withdraw</a></li>
                                                                        <li><a href="#" className="btn-style h-36 transparent" onClick={onAssetsDepositWalletShow}>Deposit</a></li>
                                                                    </ul>
                                                                </div>
                                                            </div> */}
                                                        </div>
                                                        <div className="asset-list-mobile">
                                                            <div className="asset-list-card">
                                                                <ul className="asset-detail">
                                                                    <li>
                                                                        <div className="name-wrapper">
                                                                            <div className="icon">
                                                                                <img src={bitcoinImage} alt="img" />
                                                                            </div>
                                                                            <div className="content">
                                                                                <p className="title w-800">Bitcoin</p>
                                                                                <p className="f-12 w-600">BTC</p>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Portfolio %</p>
                                                                        <p className="p w-600">12%</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Price</p>
                                                                        <p className="p w-600">0.00323 USD</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Balance</p>
                                                                        <p className="p w-600">0 BTC</p>
                                                                    </li>
                                                                </ul>
                                                                <ul className="asset-btn">
                                                                    <li><a href="#" className="btn-style transparent" onClick={onAssetsWithdrawMobileShow}>Withdraw</a></li>
                                                                    <li><a href="#" className="btn-style transparent" onClick={onAssetsDepositWalletMobileShow}>Deposit</a></li>
                                                                </ul>
                                                            </div>
                                                            <div className="asset-list-card">
                                                                <ul className="asset-detail">
                                                                    <li>
                                                                        <div className="name-wrapper">
                                                                            <div className="icon">
                                                                                <img src={bitcoinImage} alt="img" />
                                                                            </div>
                                                                            <div className="content">
                                                                                <p className="title w-800">Bitcoin</p>
                                                                                <p className="f-12 w-600">BTC</p>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Portfolio %</p>
                                                                        <p className="p w-600">12%</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Price</p>
                                                                        <p className="p w-600">0.00323 USD</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Balance</p>
                                                                        <p className="p w-600">0 BTC</p>
                                                                    </li>
                                                                </ul>
                                                                <ul className="asset-btn">
                                                                    <li><a href="#" className="btn-style transparent">Withdraw</a></li>
                                                                    <li><a href="#" className="btn-style transparent">Deposit</a></li>
                                                                </ul>
                                                            </div>

                                                            <div className="asset-list-card">
                                                                <ul className="asset-detail">
                                                                    <li>
                                                                        <div className="name-wrapper">
                                                                            <div className="icon">
                                                                                <img src={bitcoinImage} alt="img" />
                                                                            </div>
                                                                            <div className="content">
                                                                                <p className="title w-800">Bitcoin</p>
                                                                                <p className="f-12 w-600">BTC</p>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Portfolio %</p>
                                                                        <p className="p w-600">12%</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Price</p>
                                                                        <p className="p w-600">0.00323 USD</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Balance</p>
                                                                        <p className="p w-600">0 BTC</p>
                                                                    </li>
                                                                </ul>
                                                                <ul className="asset-btn">
                                                                    <li><a href="#" className="btn-style transparent">Withdraw</a></li>
                                                                    <li><a href="#" className="btn-style transparent">Deposit</a></li>
                                                                </ul>
                                                            </div>
                                                            <div className="asset-list-card">
                                                                <ul className="asset-detail">
                                                                    <li>
                                                                        <div className="name-wrapper">
                                                                            <div className="icon">
                                                                                <img src={bitcoinImage} alt="img" />
                                                                            </div>
                                                                            <div className="content">
                                                                                <p className="title w-800">Bitcoin</p>
                                                                                <p className="f-12 w-600">BTC</p>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Portfolio %</p>
                                                                        <p className="p w-600">12%</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Price</p>
                                                                        <p className="p w-600">0.00323 USD</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Balance</p>
                                                                        <p className="p w-600">0 BTC</p>
                                                                    </li>
                                                                </ul>
                                                                <ul className="asset-btn">
                                                                    <li><a href="#" className="btn-style transparent">Withdraw</a></li>
                                                                    <li><a href="#" className="btn-style transparent">Deposit</a></li>
                                                                </ul>
                                                            </div>

                                                            <div className="asset-list-card">
                                                                <ul className="asset-detail">
                                                                    <li>
                                                                        <div className="name-wrapper">
                                                                            <div className="icon">
                                                                                <img src={bitcoinImage} alt="img" />
                                                                            </div>
                                                                            <div className="content">
                                                                                <p className="title w-800">Bitcoin</p>
                                                                                <p className="f-12 w-600">BTC</p>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Portfolio %</p>
                                                                        <p className="p w-600">12%</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Price</p>
                                                                        <p className="p w-600">0.00323 USD</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Balance</p>
                                                                        <p className="p w-600">0 BTC</p>
                                                                    </li>
                                                                </ul>
                                                                <ul className="asset-btn">
                                                                    <li><a href="#" className="btn-style transparent">Withdraw</a></li>
                                                                    <li><a href="#" className="btn-style transparent">Deposit</a></li>
                                                                </ul>
                                                            </div>
                                                            <div className="asset-list-card">
                                                                <ul className="asset-detail">
                                                                    <li>
                                                                        <div className="name-wrapper">
                                                                            <div className="icon">
                                                                                <img src={bitcoinImage} alt="img" />
                                                                            </div>
                                                                            <div className="content">
                                                                                <p className="title w-800">Bitcoin</p>
                                                                                <p className="f-12 w-600">BTC</p>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Portfolio %</p>
                                                                        <p className="p w-600">12%</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Price</p>
                                                                        <p className="p w-600">0.00323 USD</p>
                                                                    </li>
                                                                    <li>
                                                                        <p className="f-10">Balance</p>
                                                                        <p className="p w-600">0 BTC</p>
                                                                    </li>
                                                                </ul>
                                                                <ul className="asset-btn">
                                                                    <li><a href="#" className="btn-style transparent">Withdraw</a></li>
                                                                    <li><a href="#" className="btn-style transparent">Deposit</a></li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="second">
                                            <div className="asset-wrapper">
                                                <div className="asset-header">
                                                    <div className="row">
                                                        <div className="col-md-6 col-7 align-self-center">
                                                            <div className="search-wrapper-v1">
                                                                <div className="form">
                                                                    <div className="form-group">
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder="Search"
                                                                            value={searchTerm}
                                                                            onChange={(e) => setSearchTerm(e.target.value)}
                                                                        />
                                                                        <img src={searchIcon} className="icon" alt="icon" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 col-5 align-self-center">
                                                            <ul className="btn-list">
                                                                <li>
                                                                    <button
                                                                        type="button"
                                                                        className="btn-style m-w-130 transparent"
                                                                        onClick={onAddWhitelistWalletShow}
                                                                    >
                                                                        Add Whitelist Wallet
                                                                    </button>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="asset-body">
                                                    <div className="asset-list-wrapper">
                                                        <div className="asset-list desktop">
                                                            <div className="table-header grid-3">
                                                                <div className="asset-item">
                                                                    <p>Wallet</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p>Balance</p>
                                                                </div>
                                                                <div className="asset-item">
                                                                    <p>
                                                                        Balance in USD <img src={arrowDownIcon} alt="icon" />
                                                                    </p>
                                                                </div>
                                                                <div className="asset-item"></div>
                                                            </div>
                                                            {userWiseWhiteList && filteredWhiteList.map((res, index) => (
                                                                <div className="asset-card grid-3" key={index}>
                                                                    <div className="asset-item">
                                                                        <div className="name-wrapper">
                                                                            <div className="wallet-icon">
                                                                                <img
                                                                                    src={walletDarkIcon}
                                                                                    className="wallet-icon"
                                                                                    alt="img"
                                                                                />
                                                                                <img
                                                                                    src={UserCurrencyResponse.filter(result => result.currencycode == res.currencycode)?.[0]?.currencyimage}
                                                                                    className="tag-icon"
                                                                                    alt="img"
                                                                                />
                                                                            </div>
                                                                            <div className="content">
                                                                                <p className="title p">
                                                                                    {res.type === "C" ? res.walletname : res.bankname}
                                                                                </p>
                                                                                <p>{res.currencycode}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="asset-item">
                                                                        <p className="p w-600">
                                                                            {res.amount} {res.currencycode}
                                                                        </p>
                                                                    </div>
                                                                    <div className="asset-item">
                                                                        <p className="p w-600">
                                                                            {res.amount} {res.currencycode}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>

                                                        <div className="asset-list-mobile">
                                                            {userWiseWhiteList && filteredWhiteList.map((res, index) => (
                                                                <div className="asset-list-card" key={index}>
                                                                    <ul className="asset-detail">
                                                                        <li>
                                                                            <div className="name-wrapper">
                                                                                <div className="wallet-icon">
                                                                                    <img
                                                                                        src={walletDarkIcon}
                                                                                        className="wallet-icon"
                                                                                        alt="img"
                                                                                    />
                                                                                    <img src={btcTagIcon} className="tag-icon" alt="img" />
                                                                                </div>
                                                                                <div className="content">
                                                                                    <p className="title">
                                                                                        {res.type === "C" ? res.walletname : res.bankname}
                                                                                    </p>
                                                                                    <p>{res.currencycode}</p>
                                                                                </div>
                                                                            </div>
                                                                        </li>
                                                                        <li>
                                                                            <p className="f-10">Portfolio %</p>
                                                                            <p className="p w-600">12%</p>
                                                                        </li>
                                                                        <li>
                                                                            <p className="f-10">Price</p>
                                                                            <p className="p w-600">0.00323 USD</p>
                                                                        </li>
                                                                        <li>
                                                                            <p className="f-10">Balance</p>
                                                                            <p className="p w-600">{res.amount} {res.currencycode}</p>
                                                                        </li>
                                                                    </ul>
                                                                    <ul className="asset-btn">
                                                                        <li>
                                                                            <button type="button" className="btn-style transparent">
                                                                                Withdraw
                                                                            </button>
                                                                        </li>
                                                                        <li>
                                                                            <button
                                                                                type="button"
                                                                                className="btn-style transparent"
                                                                                onClick={onWalletsDepositWalletMobileShow}
                                                                            >
                                                                                Deposit
                                                                            </button>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            ))}
                                                        </div>

                                                        <TablePagination
                                                            totalData={whiteListCount}
                                                            pageLimit={whiteListLimit}
                                                            currentPage={whiteListCurrentPage}
                                                            onPageChange={handelwhitelistwallet}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </Tab.Pane>

                                    </Tab.Content>
                                </div>
                            </Tab.Container>
                        </div>
                    </div>
                </div >
            </section >}

            {/* Deposit Modal Start */}
            {/* <Modal size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered className="modal deposit-wallet-modal" show={depositShow} onHide={onDepositClose}>
                <Modal.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <div className="row">
                                <div className="col-6 align-self-center">
                                    <h3 className="h3">Deposit</h3>
                                </div>
                                <div className="col-6 align-self-center">
                                    <div className="reset-wrapper">
                                        <a href="#" onClick={onDepositClose}><img src={crossIcon} alt="icon" /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-body">
                            <div className="deposit-wrapper">
                                <div className="deposit-item">
                                    <h3>Asset</h3>
                                    <CoinSelectDropdown
                                        options={selectCoinOptions}
                                        onSelect={onSelectCoin}
                                        placeholderIcon={walletIcon}
                                        className="coin-dropdown"
                                    />
                                </div>
                                <div className="deposit-item">
                                    <h3>Amount</h3>
                                    <div className="deposit-card">
                                        <div className="row">
                                            <div className="col-6 align-self-end align-self-md-center">
                                                <div className="amount-tabs">
                                                    <Tab.Container defaultActiveKey="first">
                                                        <div className="tabs-header">
                                                            <Nav variant="pills">
                                                                <Nav.Item>
                                                                    <Nav.Link eventKey="first"><p className="p w-600">USD</p></Nav.Link>
                                                                </Nav.Item>
                                                                <Nav.Item>
                                                                    <Nav.Link eventKey="second"><p className="p w-600">BTC</p></Nav.Link>
                                                                </Nav.Item>
                                                            </Nav>
                                                        </div>
                                                        <div className="tabs-body">
                                                            <Tab.Content>
                                                                <Tab.Pane eventKey="first">
                                                                    <div className="amount-input">
                                                                        <input type="text" placeholder="Enter Amount" />
                                                                    </div>
                                                                </Tab.Pane>
                                                                <Tab.Pane eventKey="second">
                                                                    <div className="amount-input">
                                                                        <input type="text" placeholder="Enter Amount" />
                                                                    </div>
                                                                </Tab.Pane>
                                                            </Tab.Content>
                                                        </div>
                                                    </Tab.Container>
                                                </div>
                                            </div>
                                            <div className="col-6 align-self-end align-self-md-center">
                                                <div className="amount-total">
                                                    <p className="p w-600">0 BTC = $0.00 USD</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="deposit-item">
                                    <h3>Deposit Into</h3>
                                    <SelectDropdown
                                        options={selectWalletOptions}
                                        onSelect={onSelectWallet}
                                        placeholder="Select a wallet"
                                        placeholderIcon={walletIcon}
                                        className="wallet-dropdown"
                                    />
                                    <div className="deposit-card deposit-search-card">
                                        //Search Wrapper 
                                        {!showQRCode && (
                                            <div className="search-wrapper-v1">
                                                <div className="form search-form">
                                                    <div className="form-group">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Search"
                                                            value={searchQuery}
                                                            onChange={(e) => setSearchQuery(e.target.value)}
                                                        />
                                                        <img src={searchIcon} className="icon" alt="icon" />
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        // No Wallet Wrapper
                                        {!showQRCode && filteredWallets.length === 0 && (
                                            <div className="no-wallet-wrapper">
                                                <div className="icon-wrapper">
                                                    <img src={walletIcon} alt="icon" />
                                                </div>
                                                <h3 className="f-17">You don’t have any wallet</h3>
                                            </div>
                                        )}

                                       // User Wallet Wrapper 
                                        {!showQRCode && filteredWallets.length > 0 && (
                                            <div className="user-wallet-wrapper">
                                                {filteredWallets.map(wallet => (
                                                    <div
                                                        key={wallet.id}
                                                        className="wallet-card"
                                                        onClick={() => setShowQRCode(true)}
                                                    >
                                                        <div className="icon-wrapper">
                                                            <img src={walletIcon} alt="icon" />
                                                        </div>
                                                        <h3 className="f-17">{wallet.name}</h3>
                                                    </div>
                                                ))}
                                            </div>
                                        )}

                                        // QR Code Wrapper 
            {showQRCode && (
                <div className="qrcode-wrapper">
                    <div className="qr-img">
                        <img src={qrcodeImage} alt="img" />
                    </div>
                    <div className="qr-content">
                        <p className="p w-700">0x233434344......34343</p>
                        <a
                            href="#"
                            className="btn-style transparent"
                            onClick={(e) => {
                                e.preventDefault(); // Prevent default anchor behavior
                                navigator.clipboard.writeText('0x233434344......34343')
                                    .then(() => console.log('Address copied to clipboard!'))
                                    .catch((err) => console.error('Failed to copy address:', err));
                            }}
                        >
                            Copy Address to Clipboard
                        </a>
                    </div>
                </div>
            )}
        </div>
                                </div >
                            </div >
                        </div >
                    </div >
                </Modal.Body >
            </Modal > */
            }
            {/* Deposit Modal End */}

            {/* Withdraw Modal Start */}
            {/* <Modal size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered className="modal deposit-wallet-modal" show={withdrawShow} onHide={onWithdrawClose}>
                <Modal.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <div className="row">
                                <div className="col-6 align-self-center">
                                    <h3 className="h3">Withdraw</h3>
                                </div>
                                <div className="col-6 align-self-center">
                                    <div className="reset-wrapper">
                                        <a href="#" onClick={onWithdrawClose}><img src={crossIcon} alt="icon" /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-body">
                            <div className="deposit-wrapper">
                                <div className="deposit-item">
                                    <h3>Asset</h3>
                                    <CoinSelectDropdown
                                        options={selectCoinOptions}
                                        onSelect={onSelectCoin}
                                        placeholderIcon={walletIcon}
                                        className="coin-dropdown"
                                    />
                                </div>
                                <div className="deposit-item">
                                    <h3>From</h3>
                                    <CoinSelectDropdown
                                        options={selectWalletCoinOptions}
                                        onSelect={onSelectWalletCoin}
                                        placeholderIcon={walletIcon}
                                        className="wallet-dropdown"
                                    />
                                </div>
                                <div className="deposit-item">
                                    <h3>Send To</h3>
                                    <div className="send-to-tabs">
                                        <Tab.Container defaultActiveKey="first">
                                            <div className="tabs-header">
                                                <Nav variant="pills">
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="first"><p className="p w-600">Any Address</p></Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="second"><p className="p w-600">Wallet</p></Nav.Link>
                                                    </Nav.Item>
                                                </Nav>
                                            </div>
                                            <div className="tabs-body">
                                                <Tab.Content>
                                                    <Tab.Pane eventKey="first">
                                                        <div className="deposit-item">
                                                            <h3>Enter Address</h3>
                                                            <div className="form">
                                                                <div className="form-group">
                                                                    <input type="text" className="form-control" placeholder="Enter address here" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Tab.Pane>
                                                    <Tab.Pane eventKey="second">
                                                        <div className="deposit-item">
                                                            <h3>Select Wallet</h3>
                                                            <SelectDropdown
                                                                options={selectWalletOptions}
                                                                onSelect={onSelectWallet}
                                                                placeholder="Select a wallet"
                                                                placeholderIcon={walletIcon}
                                                                className="wallet-dropdown"
                                                            />
                                                        </div>
                                                    </Tab.Pane>
                                                </Tab.Content>
                                            </div>
                                        </Tab.Container>
                                    </div>
                                </div>
                                <div className="deposit-item">
                                    <h3>Amount</h3>
                                    <div className="deposit-card">
                                        <div className="row">
                                            <div className="col-6 align-self-end align-self-md-center">
                                                <div className="amount-tabs">
                                                    <Tab.Container defaultActiveKey="first">
                                                        <div className="tabs-header">
                                                            <Nav variant="pills">
                                                                <Nav.Item>
                                                                    <Nav.Link eventKey="first"><p className="p w-600">USD</p></Nav.Link>
                                                                </Nav.Item>
                                                                <Nav.Item>
                                                                    <Nav.Link eventKey="second"><p className="p w-600">BTC</p></Nav.Link>
                                                                </Nav.Item>
                                                            </Nav>
                                                        </div>
                                                        <div className="tabs-body">
                                                            <Tab.Content>
                                                                <Tab.Pane eventKey="first">
                                                                    <div className="amount-input">
                                                                        <input type="text" placeholder="Enter Amount" />
                                                                    </div>
                                                                </Tab.Pane>
                                                                <Tab.Pane eventKey="second">
                                                                    <div className="amount-input">
                                                                        <input type="text" placeholder="Enter Amount" />
                                                                    </div>
                                                                </Tab.Pane>
                                                            </Tab.Content>
                                                        </div>
                                                    </Tab.Container>
                                                </div>
                                            </div>
                                            <div className="col-6 align-self-end align-self-md-center">
                                                <div className="amount-total">
                                                    <p className="p w-600">0 BTC = $0.00 USD</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-footer">
                            <ul className="btn-list">
                                <li><a href="#" className="btn-style">Confirm</a></li>
                            </ul>
                        </div>
                    </div>
                </Modal.Body>
            </Modal> */}
            {/* Withdraw Modal End */}


            {/* Assets Deposit Wallet Modal Start */}
            <Modal
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="modal deposit-select-wallet-modal"
                show={assetsDepositWalletShow}
                onHide={onAssetsDepositWalletClose}
            >
                <Modal.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <div className="row">
                                <div className="col-6 align-self-center">
                                    <h3 className="h3">Deposit</h3>
                                </div>
                                <div className="col-5 align-self-center">
                                    <div className="selected-coin">
                                        <div className="icon">
                                            {selectedDepositeCurrency?.currencyimage && (
                                                <img src={selectedDepositeCurrency.currencyimage} alt="icon" />
                                            )}
                                            <p className="p w-700">{selectedDepositeCurrency?.currencyname}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-1 align-self-center text-end">
                                    <button onClick={onAssetsDepositWalletClose} className="btn-close-modal">
                                        <img src={crossIcon} alt="Close" />
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-body">
                            <div className="deposit-wrapper">
                                <div className="deposit-item">
                                    <h3>Address</h3>
                                    <div className="deposit-card">
                                        {selectedDepositeCurrency?.address && (
                                            <div className="qrcode-wrapper">
                                                <div className="qr-img">
                                                    <img src={'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=' + selectedDepositeCurrency.address} alt="img" />
                                                </div>
                                                <div className="qr-content">
                                                    <p className="p w-700">{selectedDepositeCurrency.address}</p>

                                                    {(selectedDepositeCurrency.currencycode).toLowerCase() == 'xdc' && <div className="address-toggle">
                                                        <span className="toggle-label">xdc</span>
                                                        <label className="switch">
                                                            <input
                                                                type="checkbox"
                                                                checked={selectedDepositeCurrency.address?.startsWith('0x')}
                                                                onChange={(e) => {
                                                                    const isChecked = e.target.checked;
                                                                    const newAddress = isChecked
                                                                        ? selectedDepositeCurrency.address.startsWith('xdc')
                                                                            ? '0x' + selectedDepositeCurrency.address.slice(3)
                                                                            : selectedDepositeCurrency.address
                                                                        : selectedDepositeCurrency.address.startsWith('0x')
                                                                            ? 'xdc' + selectedDepositeCurrency.address.slice(2)
                                                                            : selectedDepositeCurrency.address;

                                                                    setSelectedDepositeCurrency({
                                                                        ...selectedDepositeCurrency,
                                                                        address: newAddress
                                                                    });
                                                                }}
                                                            />
                                                            <span className="slider"></span>
                                                        </label>
                                                        <span className="toggle-label">0x</span>
                                                    </div>}

                                                    <a
                                                        href="#"
                                                        className="btn-style transparent"
                                                        onClick={(e) => {
                                                            try {
                                                                e.preventDefault();
                                                                navigator.clipboard.writeText(selectedDepositeCurrency.address)
                                                                    .then(() => console.log('Address copied to clipboard!'))
                                                                    .catch((err) => console.error('Failed to copy address:', err));
                                                            }
                                                            catch (err) {
                                                                e.preventDefault();
                                                                console.error(err);
                                                            }
                                                        }}
                                                    >
                                                        Copy Address to Clipboard
                                                    </a>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            {/* Assets Deposit Wallet Modal End */}

            {/* Wallets Deposit Wallet Modal Start */}
            <Modal size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered className="modal deposit-select-wallet-modal" show={walletsDepositWalletShow} onHide={onWalletsDepositWalletClose}>
                <Modal.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <div className="row">
                                <div className="col-6 align-self-center">
                                    <h3 className="h3">Deposit</h3>
                                </div>
                                <div className="col-6 align-self-center">
                                    {/*<div className="reset-wrapper">
                                        <a href="#" onClick={onAssetsDepositWalletClose}><img src={crossIcon} alt="icon"/></a>
                                    </div>*/}
                                    <div className="selected-coin">
                                        <div className="icon">
                                            <img src={bitcoinImage} alt="icon" />
                                            <p className="p w-700">BTC</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-6 align-self-center text-end">
                                    <button onClick={onWalletsDepositWalletClose} className="btn-close-modal">
                                        <img src={crossIcon} alt="Close" />
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-body">
                            <div className="deposit-wrapper">
                                <div className="deposit-item">
                                    <div className="item-header">
                                        <div className="row">
                                            <div className="col-md-4 align-self-center">
                                                <h3>Address</h3>
                                            </div>
                                            <div className="col-md-8 align-self-center">
                                                <p className="p w-600">John’s Test BTC Wallet</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="deposit-card">
                                        <div className="qrcode-wrapper">
                                            <div className="qr-img">
                                                <img src={qrcodeImage} alt="img" />
                                            </div>
                                            <div className="qr-content">
                                                <p className="p w-700">0x233434344......34343</p>
                                                {/*<a
                                                    href="#"
                                                    className="btn-style transparent"
                                                    onClick={(e) => {
                                                        e.preventDefault(); // Prevent default anchor behavior
                                                        navigator.clipboard.writeText('0x233434344......34343')
                                                            .then(() => console.log('Address copied to clipboard!'))
                                                            .catch((err) => console.error('Failed to copy address:', err));
                                                    }}
                                                >
                                                    Copy Address to Clipboard
                                                </a>*/}
                                                <a
                                                    href="#"
                                                    className="btn-style transparent"
                                                    onClick={onFiatDepositShow}
                                                >
                                                    Copy Address to Clipboard
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            {/* Wallets Deposit Wallet Modal End */}

            {/* create wallet new changes start  */}
            <Modal size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered className="modal deposit-select-wallet-modal assets-withdraw-funds-modal" show={createWallet} onHide={onCreateWalletclose}>
                <Modal.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header d-flex justify-content-between">
                            <h3 className="h3">Create Wallet</h3>
                            <div className="col-6 d-flex justify-content-end">
                                <button onClick={onCreateWalletclose} className="btn-close-modal">
                                    <img src={crossIcon} alt="Close" />
                                </button>
                            </div>
                        </div>

                        <div className="wallet-body">
                            <div className="deposit-wrapper">
                                <div className="otc-compare-wrapper">
                                    <div className="deposit-item">
                                        <h3>Select Currency</h3>
                                        {deafultCurrency &&
                                            <SelectDropdown
                                                options={deafultCurrency.map(res => { return { label: res.currencycode, code: res.currencycode, ...res } })}
                                                onSelect={(e) => onSelectDeafultCurrency(e)}
                                                placeholder="Choose Asset"
                                                placeholderIcon={btcTagIcon}
                                                className="otc-dropdown"
                                                showIcon={false}
                                            />}
                                        {createWalletValidation &&
                                            <span className="top-notch">Opps!!, May be this currency already with user or somethig wrong..</span>}
                                    </div>
                                    <div className="compare-icon">

                                    </div>
                                </div>
                                {/* <div className="deposit-item">
                                    <h3>Amount</h3>
                                    <div className="form">
                                        <div className="form-group">
                                            <input type="text" className="form-control" placeholder="Enter Amount" />
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        <div className="wallet-footer">
                            <ul className="btn-list">
                                {!createWalletValidation && <li><a href="#" className="btn-style" onClick={handelcreatewallet}>Submit</a></li>}
                            </ul>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            {/* create wallet new changes end  */}

            {/* Fiat Deposit Modal Start */}
            <Modal size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered className="modal deposit-select-wallet-modal fiat-deposit-modal" show={fiatDepositShow} onHide={onFiatDepositClose}>
                <Modal.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <div className="row">
                                <div className="col-6 align-self-center">
                                    <h3 className="h3">Deposit</h3>
                                </div>
                                <div className="col-5 align-self-center">
                                    {/*<div className="reset-wrapper">
                                        <a href="#" onClick={onAssetsDepositWalletClose}><img src={crossIcon} alt="icon"/></a>
                                    </div>*/}
                                </div>
                                <div className="col-1 align-self-center text-end">
                                    <button onClick={onFiatDepositClose} className="btn-close-modal">
                                        <img src={crossIcon} alt="Close" />
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-body">
                            <div className="account-detail-main">
                                <h3 className="f-18">Account Details</h3>
                                {fiatValidation && <span className="text-danger">{fiatValidation}</span>}
                                <div className="account-detail-wrapper">
                                    {fiatDepositDetails && fiatDepositDetails.map((bank, index) => {
                                        try {
                                            console.log(bank);
                                            return <div className="account-card" key={index} style={{
                                                border: selectedDepositBank === bank ? "2px solid rgb(141, 141, 141)" : "1px solid #B5D2DF", // Border highlight
                                                transition: "background-color 1s ease"
                                            }} onClick={(e) => handelSelectedDepositBank(bank)}>
                                                <div className="bank-name">
                                                    <div className="icon">
                                                        <img src={bankIcon} alt="icon" />
                                                    </div>
                                                    <p className="f-12 w-700">{bank.BankName}</p>
                                                </div>
                                                <ul className="account-detail-list">
                                                    {Object.entries(bank.BankDetails).map(([key, value]) => (
                                                        <li key={key}>
                                                            <p className="f-10 w-600 title">{key}</p>
                                                            <p className="f-12 w-600">{value}</p>
                                                        </li>
                                                    ))}
                                                </ul>
                                                <div className="form">
                                                    <div className="form-group">
                                                        <input type="text" placeholder="Enter your IBAN/Account Number" className="form-control" onChange={(e) => { setFiatValidation(false); setSelectedFaitFromSourceAccount(e.target.value) }}></input>
                                                    </div>
                                                </div>
                                                <div className="form">
                                                    <div className="form-group">
                                                        <input type="number" placeholder="Enter your Amount" className="form-control" onChange={(e) => setSelectedFaitAmount(e.target.value)}></input>
                                                    </div>
                                                </div>
                                                <div className="deposit-item">
                                                    {uploadFiatFile ? (
                                                        <div className="file-preview">
                                                            <div className="file-info">
                                                                <span className="file-icon">📄</span>
                                                                <div>
                                                                    <p className="file-name">{uploadFiatFile?.target?.files?.[0]?.name}</p>
                                                                    <p className="file-size">
                                                                        {(uploadFiatFile?.target?.files?.[0]?.size / 1024 / 1024).toFixed(2)} MB
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <button
                                                                className="remove-btn"
                                                                onClick={() => setUploadFiatFile(false)}
                                                            >
                                                                X
                                                            </button>
                                                        </div>
                                                    ) : (<><h3>Upload receipts</h3>
                                                        <div className="form">
                                                            <div className="form-group">
                                                                <div className="upload-card">
                                                                    <label htmlFor="upload-file" className="upload-label">
                                                                        <div className="upload-gallery-wrapper">
                                                                            <div className="upload-content">
                                                                                <img src={uploadFileIcon} className="upload-icon" alt="Upload Icon" />
                                                                                <p className="f-13 w-600">Drag or Drop Files Here</p>
                                                                                <p className="f-13 w-600 or">or</p>
                                                                                <a className="btn-style transparent">Upload Files</a>
                                                                            </div>
                                                                        </div>
                                                                    </label>
                                                                    <input type="file" accept=".pdf,application/pdf" id="upload-file" onChange={setUploadFiatFile} />
                                                                </div>

                                                            </div>

                                                        </div>
                                                    </>)}
                                                </div>
                                            </div>

                                        } catch (err) { console.log(err); return <>somethig went wrong!!!</> }
                                    })}
                                    {/*<div className="account-card">
                                        <div className="bank-name">
                                            <div className="icon">
                                                <img src={bankIcon} alt="icon" />
                                            </div>
                                            <p className="f-12 w-700">Bank of America</p>
                                        </div>
                                        <ul className="account-detail-list">
                                            <li>
                                                <p className="f-10 w-600 title">Account No</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">SWIFT Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">MICR Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">Branch Address</p>
                                                <p className="f-12 w-600">Charlotte, North Carolina, United States</p>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="account-card">
                                        <div className="bank-name">
                                            <div className="icon">
                                                <img src={bankIcon} alt="icon" />
                                            </div>
                                            <p className="f-12 w-700">Bank of America</p>
                                        </div>
                                        <ul className="account-detail-list">
                                            <li>
                                                <p className="f-10 w-600 title">Account No</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">SWIFT Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">MICR Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">Branch Address</p>
                                                <p className="f-12 w-600">Charlotte, North Carolina, United States</p>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="account-card">
                                        <div className="bank-name">
                                            <div className="icon">
                                                <img src={bankIcon} alt="icon" />
                                            </div>
                                            <p className="f-12 w-700">Bank of America</p>
                                        </div>
                                        <ul className="account-detail-list">
                                            <li>
                                                <p className="f-10 w-600 title">Account No</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">SWIFT Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">MICR Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">Branch Address</p>
                                                <p className="f-12 w-600">Charlotte, North Carolina, United States</p>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="account-card">
                                        <div className="bank-name">
                                            <div className="icon">
                                                <img src={bankIcon} alt="icon" />
                                            </div>
                                            <p className="f-12 w-700">Bank of America</p>
                                        </div>
                                        <ul className="account-detail-list">
                                            <li>
                                                <p className="f-10 w-600 title">Account No</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">SWIFT Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">MICR Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">Branch Address</p>
                                                <p className="f-12 w-600">Charlotte, North Carolina, United States</p>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="account-card">
                                        <div className="bank-name">
                                            <div className="icon">
                                                <img src={bankIcon} alt="icon" />
                                            </div>
                                            <p className="f-12 w-700">Bank of America</p>
                                        </div>
                                        <ul className="account-detail-list">
                                            <li>
                                                <p className="f-10 w-600 title">Account No</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">SWIFT Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">MICR Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">Branch Address</p>
                                                <p className="f-12 w-600">Charlotte, North Carolina, United States</p>
                                            </li>
                                        </ul>
                                    </div> */}
                                </div >
                            </div>
                            <div className="upload-wrapper">
                                <div className="row">
                                    {/* <div className="col-md-8 align-self-center">
                                        <p className="f-15 w-600">Transferred the amount? Upload proof to confirm deposit</p>
                                    </div> */}
                                    <div className="col-md-4 align-self-center">
                                        <ul className="btn-list">
                                            <li><a href="#" className="btn-style transparent" onClick={hanselDepositFiatCurrency}>Submit</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            {/* Fiat Deposit Modal End */}


            {/* Upload Proof Modal Start */}
            <Modal size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered className="modal deposit-select-wallet-modal fiat-deposit-modal" show={uploadProofShow} onHide={onUploadProofClose}>
                <Modal.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <div className="row">
                                <div className="col-6 align-self-center">
                                    <h3 className="h3">Deposit</h3>
                                </div>
                                <div className="col-5 align-self-center">
                                    {/*<div className="reset-wrapper">
                                        <a href="#" onClick={onAssetsDepositWalletClose}><img src={crossIcon} alt="icon"/></a>
                                    </div>*/}
                                </div>
                                <div className="col-1 align-self-center text-end">
                                    <button onClick={onUploadProofClose} className="btn-close-modal">
                                        <img src={crossIcon} alt="Close" />
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-body">
                            <div className="deposit-wrapper">
                                <div className="deposit-item">
                                    <h3>Enter Amount Deposited</h3>
                                    <div className="form">
                                        <div className="form-group">
                                            <input type="text" className="form-control" placeholder="Enter amount" />
                                        </div>
                                    </div>
                                </div>
                                <div className="deposit-item">
                                    <h3>Enter Account Details</h3>
                                    <div className="form">
                                        <div className="form-group">
                                            <input type="text" className="form-control" placeholder="Enter account number" />
                                        </div>
                                    </div>
                                </div>
                                <div className="deposit-item">
                                    <h3>Upload transfer receipts </h3>
                                    <div className="form">
                                        <div className="form-group">
                                            <div className="upload-card">
                                                <label htmlFor="upload-gallery-video" className="upload-label">
                                                    <div className="upload-gallery-wrapper">
                                                        <div className="upload-content">
                                                            <img src={uploadFileIcon} className="upload-icon" alt="Upload Icon" />
                                                            <p className="f-13 w-600">Drag or Drop Files Here</p>
                                                            <p className="f-13 w-600 or">or</p>
                                                            <a href="#" className="btn-style transparent">Upload Files</a>
                                                        </div>
                                                    </div>
                                                </label>
                                                <input type="file" id="upload-gallery-video" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="upload-wrapper">
                                    <ul className="btn-list">
                                        <li><a href="#" className="btn-style transparent">Submit</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            {/* Upload Proof Modal End */}


            {/* Assets Withdraw Modal Start */}
            {/* <Modal size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered className="modal deposit-select-wallet-modal assets-withdraw-modal" show={assetsWithdrawShow} onHide={onAssetsWithdrawClose}>
                <Modal.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <div className="row">
                                <div className="col-6 align-self-center">
                                    <h3 className="h3">Withdraw</h3>
                                </div>
                                <div className="col-6 align-self-center">
                                    <div className="reset-wrapper">
                                        <a href="#" onClick={onWithdrawClose}><img src={crossIcon} alt="icon" /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-body">
                            <div className="deposit-wrapper">
                                <div className="deposit-item">
                                    <h3>Asset</h3>
                                    <CoinSelectDropdown
                                        options={selectCoinOptions}
                                        onSelect={onSelectCoin}
                                        placeholderIcon={walletIcon}
                                        className="coin-dropdown"
                                    />
                                </div>
                                <div className="deposit-item">
                                    <div className="item-header">
                                        <div className="row">
                                            <div className="col-3">
                                                <h3>From</h3>
                                            </div>
                                            <div className="col-9">
                                                <p className="p w-600">Address : 0x2344383848489399c8388484</p>
                                            </div>
                                        </div>
                                    </div>
                                    <SelectDropdown
                                        options={selectWalletOptions}
                                        onSelect={onSelectWallet}
                                        placeholder="Select a wallet"
                                        placeholderIcon={walletIcon}
                                        className="wallet-dropdown"
                                        showSpecificItem={1} // This will pre-select specific Wallet by passing index
                                    />
                                </div>
                                <div className="deposit-item">
                                    <h3>Enter Address</h3>
                                    <div className="form">
                                        <div className="form-group">
                                            <input type="text" className="form-control" placeholder="Enter address here" />
                                        </div>
                                    </div>
                                </div>
                                <div className="deposit-item">
                                    <div className="item-header">
                                        <div className="row">
                                            <div className="col-3">
                                                <h3>Amount</h3>
                                            </div>
                                            <div className="col-9">
                                                <p className="p w-600">Available Balance : 2.03 BTC</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form">
                                        <div className="form-group">
                                            <input type="text" className="form-control" placeholder="Enter BTC" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-footer">
                            <ul className="btn-list">
                                <li><a href="#" className="btn-style" onClick={onAssetsWithdrawFundsShow}>Confirm</a></li>
                            </ul>
                        </div>
                    </div>
                </Modal.Body>
            </Modal> */}
            {/* Assets Withdraw Modal End */}


            {/* Assets Withdraw Funds Modal Start */}
            <Modal size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered className="modal deposit-select-wallet-modal assets-withdraw-funds-modal" show={assetsWithdrawFundsShow} onHide={onAssetsWithdrawFundsClose}>
                <Modal.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <div className="row">
                                <div className="col-4 align-self-center">
                                    <h3 className="h3">Withdraw</h3>
                                </div>
                                <div className="col-7 align-self-center">
                                    <div className="available-funds">
                                        <h3 className="f-20">Available Funds : {selectedWithdrawCurrency.priceamount} {selectedWithdrawCurrency.currencycode}</h3>
                                    </div>
                                </div>
                                <div className="col-1 align-self-center text-end">
                                    <button onClick={onAssetsWithdrawFundsClose} className="btn-close-modal">
                                        <img src={crossIcon} alt="Close" />
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-body">
                            <div className="deposit-wrapper">
                                <div className="deposit-item">
                                    <h3>{selectedWithdrawCurrency.type == 'C' ? "Add a wallet address to withdraw money into" : "Add a Account to withdraw money into"}</h3>
                                    {/* <div className="form">
                                        <div className="form-group">
                                            <input type="text" onChange={(e) => setWithdrawaaddress(e.target.value)} className="form-control black-placeholder" placeholder="Enter  Address/Account" />

                                        </div>
                                    </div> */}

                                    <SelectDropdown
                                        options={selectedWithdrawCurrency.type == 'C' ? selectWalletCoinOptions.filter(res => res.currencycode == selectedWithdrawCurrency.currencycode) : selectBanksOptions}
                                        onSelect={onSelectBanksandWallet}
                                        placeholder={selectedWithdrawCurrency.type == 'C' ? "Select a Wallet" : "Select a bank"}
                                        placeholderIcon={selectedWithdrawCurrency.type == 'C' ? walletIcon : bankIcon}
                                        className="wallet-dropdown"
                                        showSpecificItem={2} // This will pre-select specific Wallet by passing index
                                    />

                                </div>
                                <div className="deposit-item">
                                    <h3>Amount{error.toString()}</h3>
                                    <div className="form">
                                        <div className="form-group">
                                            <div className="amount-wrapper">
                                                <div className="icon"><p className="p w-600">$</p></div>
                                                <input type="number" onChange={(e) => handelInput(e, Number(selectedWithdrawCurrency.priceamount))} className="form-control black-placeholder" placeholder={"Enter Amount in " + selectedWithdrawCurrency.currencycode} />

                                            </div>
                                            {error && <span className="top-notch text-danger">{error}</span>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {!error &&
                            <div className="wallet-footer">
                                <ul className="btn-list">
                                    <li><a href="#" className="btn-style" onClick={() => selectedWithdrawsubmit(selectedWithdrawCurrency)}>Submit</a></li>
                                </ul>
                            </div>
                        }
                    </div>
                </Modal.Body>
            </Modal>
            {/* Assets Withdraw Funds Modal End */}

            {/* Add Whitelist Wallet Modal Start */}
            <Whitelist
                UserCurrencyResponse={UserCurrencyResponse.map(res => {
                    if (res.type == 'F') {
                        res.currencyimage = res.currencycode.toLowerCase() == 'usd' ? usdLogo : euroLogo;
                    }
                    return {
                        label: res.currencycode,
                        shortName: res.currencycode,
                        icon: res.currencyimage,
                        type: res.type
                    };
                })}
                addWhitelistWalletShow={addWhitelistWalletShow}
                onAddWhitelistWalletClose={onAddWhitelistWalletClose}
                onWithdrawClose={onWithdrawClose}  // Make sure this matches the prop name in Whitelist
                email={(JSON.parse(sessionvalue))?.email || ''}
            />

            {/* Add Whitelist Wallet Modal End */}



            {/* Mobile Popups Start */}




            {/* Wallets Deposit Wallet Modal Start */}
            <Offcanvas show={walletsDepositWalletMobileShow} className="deposit-select-wallet-modal h-468" onHide={onWalletsDepositWalletMobileClose} placement={'bottom'}>
                <Offcanvas.Header closeButton>
                    {/*<Offcanvas.Title>Offcanvas</Offcanvas.Title>*/}
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <div className="row">
                                <div className="col-6 align-self-center">
                                    <h3 className="h3">Deposit</h3>
                                </div>
                                <div className="col-6 align-self-center">
                                    {/*<div className="reset-wrapper">
                                        <a href="#" onClick={onAssetsDepositWalletClose}><img src={crossIcon} alt="icon"/></a>
                                    </div>*/}
                                    <div className="selected-coin">
                                        <div className="icon">
                                            <img src={bitcoinImage} alt="icon" />
                                            <p className="p w-700">BTC</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-body">
                            <div className="deposit-wrapper">
                                <div className="deposit-item">
                                    <div className="item-header">
                                        <div className="row">
                                            <div className="col-4 align-self-center">
                                                <h3>Address</h3>
                                            </div>
                                            <div className="col-8 align-self-center">
                                                <p className="p w-600">John’s Test BTC Wallet</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="deposit-card">
                                        <div className="qrcode-wrapper">
                                            <div className="qr-img">
                                                <img src={qrcodeImage} alt="img" />
                                            </div>
                                            <div className="qr-content">
                                                <p className="p w-700">0x233434344......34343</p>
                                                {/*<a
                                                    href="#"
                                                    className="btn-style transparent"
                                                    onClick={(e) => {
                                                        e.preventDefault(); // Prevent default anchor behavior
                                                        navigator.clipboard.writeText('0x233434344......34343')
                                                            .then(() => console.log('Address copied to clipboard!'))
                                                            .catch((err) => console.error('Failed to copy address:', err));
                                                    }}
                                                >
                                                    Copy Address to Clipboard
                                                </a>*/}
                                                <a
                                                    href="#"
                                                    className="btn-style transparent"
                                                    onClick={onFiatDepositMobileShow}
                                                >
                                                    Copy Address to Clipboard
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
            {/* Wallets Deposit Wallet Modal End */}


            {/* Fiat Deposit Modal Start */}
            <Offcanvas show={fiatDepositMobileShow} className="deposit-select-wallet-modal h-635" onHide={onFiatDepositMobileClose} placement={'bottom'}>
                <Offcanvas.Header closeButton>
                    {/*<Offcanvas.Title>Offcanvas</Offcanvas.Title>*/}
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <div className="row">
                                <div className="col-6 align-self-center">
                                    <h3 className="h3">Deposit</h3>
                                </div>
                                <div className="col-6 align-self-center">
                                    {/*<div className="reset-wrapper">
                                        <a href="#" onClick={onAssetsDepositWalletClose}><img src={crossIcon} alt="icon"/></a>
                                    </div>*/}
                                </div>
                            </div>
                        </div>
                        <div className="wallet-body">
                            <div className="account-detail-main">
                                <h3 className="f-18">Account Details</h3>
                                <div className="account-detail-wrapper">
                                    <div className="account-card">
                                        <div className="bank-name">
                                            <div className="icon">
                                                <img src={bankIcon} alt="icon" />
                                            </div>
                                            <p className="f-12 w-700">Bank of America</p>
                                        </div>
                                        <ul className="account-detail-list">
                                            <li>
                                                <p className="f-10 w-600 title">Account No</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">SWIFT Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">MICR Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">Branch Address</p>
                                                <p className="f-12 w-600">Charlotte, North Carolina, United States</p>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="account-card">
                                        <div className="bank-name">
                                            <div className="icon">
                                                <img src={bankIcon} alt="icon" />
                                            </div>
                                            <p className="f-12 w-700">Bank of America</p>
                                        </div>
                                        <ul className="account-detail-list">
                                            <li>
                                                <p className="f-10 w-600 title">Account No</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">SWIFT Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">MICR Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">Branch Address</p>
                                                <p className="f-12 w-600">Charlotte, North Carolina, United States</p>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="account-card">
                                        <div className="bank-name">
                                            <div className="icon">
                                                <img src={bankIcon} alt="icon" />
                                            </div>
                                            <p className="f-12 w-700">Bank of America</p>
                                        </div>
                                        <ul className="account-detail-list">
                                            <li>
                                                <p className="f-10 w-600 title">Account No</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">SWIFT Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">MICR Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">Branch Address</p>
                                                <p className="f-12 w-600">Charlotte, North Carolina, United States</p>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="account-card">
                                        <div className="bank-name">
                                            <div className="icon">
                                                <img src={bankIcon} alt="icon" />
                                            </div>
                                            <p className="f-12 w-700">Bank of America</p>
                                        </div>
                                        <ul className="account-detail-list">
                                            <li>
                                                <p className="f-10 w-600 title">Account No</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">SWIFT Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">MICR Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">Branch Address</p>
                                                <p className="f-12 w-600">Charlotte, North Carolina, United States</p>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="account-card">
                                        <div className="bank-name">
                                            <div className="icon">
                                                <img src={bankIcon} alt="icon" />
                                            </div>
                                            <p className="f-12 w-700">Bank of America</p>
                                        </div>
                                        <ul className="account-detail-list">
                                            <li>
                                                <p className="f-10 w-600 title">Account No</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">SWIFT Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">MICR Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">Branch Address</p>
                                                <p className="f-12 w-600">Charlotte, North Carolina, United States</p>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="account-card">
                                        <div className="bank-name">
                                            <div className="icon">
                                                <img src={bankIcon} alt="icon" />
                                            </div>
                                            <p className="f-12 w-700">Bank of America</p>
                                        </div>
                                        <ul className="account-detail-list">
                                            <li>
                                                <p className="f-10 w-600 title">Account No</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">SWIFT Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">MICR Code</p>
                                                <p className="f-12 w-600">23737382823838</p>
                                            </li>
                                            <li>
                                                <p className="f-10 w-600 title">Branch Address</p>
                                                <p className="f-12 w-600">Charlotte, North Carolina, United States</p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="upload-wrapper">
                                <div className="row">
                                    <div className="col-md-8 align-self-center">
                                        <p className="f-15 w-600">Transferred the amount? <br className="mobile" /> Upload proof to confirm deposit</p>
                                    </div>
                                    <div className="col-md-4 align-self-center">
                                        <ul className="btn-list">
                                            <li><a href="#" className="btn-style transparent" onClick={onUploadProofMobileShow}>Upload Proof</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
            {/* Fiat Deposit Modal End */}

            {/* Upload Proof Modal Start */}
            <Offcanvas show={uploadProofMobileShow} className="deposit-select-wallet-modal h-610" onHide={onUploadProofMobileClose} placement={'bottom'}>
                <Offcanvas.Header closeButton>
                    {/*<Offcanvas.Title>Offcanvas</Offcanvas.Title>*/}
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <div className="row">
                                <div className="col-6 align-self-center">
                                    <h3 className="h3">Deposit</h3>
                                </div>
                                <div className="col-6 align-self-center">
                                    {/*<div className="reset-wrapper">
                                        <a href="#" onClick={onAssetsDepositWalletClose}><img src={crossIcon} alt="icon"/></a>
                                    </div>*/}
                                </div>
                            </div>
                        </div>
                        <div className="wallet-body">
                            <div className="deposit-wrapper">
                                <div className="deposit-item">
                                    <h3>Enter Amount Deposited</h3>
                                    <div className="form">
                                        <div className="form-group">
                                            <input type="text" className="form-control" placeholder="Enter amount" />
                                        </div>
                                    </div>
                                </div>
                                <div className="deposit-item">
                                    <h3>Enter Account Details</h3>
                                    <div className="form">
                                        <div className="form-group">
                                            <input type="text" className="form-control" placeholder="Enter account number" />
                                        </div>
                                    </div>
                                </div>
                                <div className="deposit-item">
                                    <h3>Upload transfer receipts </h3>
                                    <div className="form">
                                        <div className="form-group">
                                            <div className="upload-card">
                                                <label htmlFor="upload-gallery-video" className="upload-label">
                                                    <div className="upload-gallery-wrapper">
                                                        <div className="upload-content">
                                                            <img src={uploadFileIcon} className="upload-icon" alt="Upload Icon" />
                                                            <p className="f-13 w-600">Drag or Drop Files Here</p>
                                                            <p className="f-13 w-600 or">or</p>
                                                            <a href="#" className="btn-style transparent">Upload Files</a>
                                                        </div>
                                                    </div>
                                                </label>
                                                <input type="file" id="upload-gallery-video" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="upload-wrapper">
                                    <ul className="btn-list">
                                        <li><a href="#" className="btn-style transparent" onClick={onUploadProofMobileClose}>Submit</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
            {/* Upload Proof Modal End */}

            {/* Assets Deposit Wallet Modal Start */}
            <Offcanvas show={assetsDepositWalletMobileShow} className="deposit-select-wallet-modal h-566" onHide={onAssetsDepositWalletMobileClose} placement={'bottom'}>
                <Offcanvas.Header closeButton>
                    {/*<Offcanvas.Title>Offcanvas</Offcanvas.Title>*/}
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <div className="row">
                                <div className="col-6 align-self-center">
                                    <h3 className="h3">Deposit</h3>
                                </div>
                                <div className="col-6 align-self-center">
                                    {/*<div className="reset-wrapper">
                                        <a href="#" onClick={onAssetsDepositWalletClose}><img src={crossIcon} alt="icon"/></a>
                                    </div>*/}
                                    <div className="selected-coin">
                                        <div className="icon">
                                            <img src={usdcIcon} alt="icon" />
                                            <p className="p w-700">{selectedDepositeCurrency.currencycode}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-body">
                            <div className="deposit-wrapper">
                                {/* <div className="deposit-item">
                                    <SelectDropdown
                                        options={selectWalletOptions}
                                        onSelect={onSelectWallet}
                                        placeholder="Select a wallet"
                                        placeholderIcon={walletIcon}
                                        className="wallet-dropdown"
                                    />
                                </div> */}
                                <div className="deposit-item">
                                    <h3>Address</h3>
                                    <div className="deposit-card">
                                        <div className="qrcode-wrapper">
                                            <div className="qr-img">
                                                <img src={'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=' + selectedDepositeCurrency.address} alt="img" />
                                            </div>
                                            <div className="qr-content">
                                                <p className="p w-700">0x233434344......34343</p>
                                                <a
                                                    href="#"
                                                    className="btn-style transparent"
                                                    onClick={(e) => {
                                                        e.preventDefault(); // Prevent default anchor behavior
                                                        navigator.clipboard.writeText('0x233434344......34343')
                                                            .then(() => console.log('Address copied to clipboard!'))
                                                            .catch((err) => console.error('Failed to copy address:', err));
                                                    }}
                                                >
                                                    Copy Address to Clipboard
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
            {/* Assets Deposit Wallet Modal End */}

            {/* Assets Withdraw Modal Start */}
            <Offcanvas show={assetsWithdrawMobileShow} className="deposit-select-wallet-modal h-644" onHide={onAssetsWithdrawMobileClose} placement={'bottom'}>
                <Offcanvas.Header closeButton>
                    {/*<Offcanvas.Title>Offcanvas</Offcanvas.Title>*/}
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <div className="row">
                                <div className="col-6 align-self-center">
                                    <h3 className="h3">Withdraw</h3>
                                </div>
                                <div className="col-6 align-self-center">
                                    <div className="reset-wrapper">
                                        {/*<a href="#" onClick={onWithdrawClose}><img src={crossIcon} alt="icon"/></a>*/}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-body">
                            <div className="deposit-wrapper">
                                <div className="deposit-item">
                                    <h3>Asset</h3>
                                    <CoinSelectDropdown
                                        options={selectCoinOptions}
                                        onSelect={onSelectCoin}
                                        placeholderIcon={walletIcon}
                                        className="coin-dropdown"
                                    />
                                </div>
                                <div className="deposit-item">
                                    <div className="item-header">
                                        <div className="row">
                                            <div className="col-3">
                                                <h3>From</h3>
                                            </div>
                                            <div className="col-9">
                                                {/*<p className="p w-600">Address : 0x2344383848489399c8388484</p>*/}
                                            </div>
                                        </div>
                                    </div>
                                    <SelectDropdown
                                        options={selectWalletOptions}
                                        onSelect={onSelectWallet}
                                        placeholder="Select a wallet"
                                        placeholderIcon={walletIcon}
                                        className="wallet-dropdown"
                                        showSpecificItem={1} // This will pre-select specific Wallet by passing index
                                    />
                                    <p className="p w-600 wallet-address-text">Address : 0x2344383848489399c8388484</p>
                                </div>
                                <div className="deposit-item">
                                    <h3>Enter Address</h3>
                                    <div className="form">
                                        <div className="form-group">
                                            <input type="text" className="form-control" placeholder="Enter address here" />
                                        </div>
                                    </div>
                                </div>
                                <div className="deposit-item">
                                    <div className="item-header">
                                        <div className="row">
                                            <div className="col-3">
                                                <h3>Amount</h3>
                                            </div>
                                            <div className="col-9">
                                                <p className="p w-600">Available Balance : 2.03 BTC</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form">
                                        <div className="form-group">
                                            <input type="text" className="form-control" placeholder="Enter BTC" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-footer">
                            <ul className="btn-list">
                                <li><a href="#" className="btn-style" onClick={onAssetsWithdrawFundsMobileShow}>Confirm</a></li>
                            </ul>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
            {/* Assets Withdraw Modal End */}

            {/* Assets Withdraw Funds Modal Start */}
            <Offcanvas show={assetsWithdrawFundsMobileShow} className="deposit-select-wallet-modal h-402" onHide={onAssetsWithdrawFundsMobileClose} placement={'bottom'}>
                <Offcanvas.Header closeButton>
                    {/*<Offcanvas.Title>Offcanvas</Offcanvas.Title>*/}
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="deposit-wallet-wrapper">
                        <div className="wallet-header">
                            <div className="row">
                                <div className="col-4 align-self-center">
                                    <h3 className="h3">Withdraw</h3>
                                </div>
                                <div className="col-8 align-self-center">
                                    <div className="available-funds">
                                        <h3 className="f-20">Available Funds : $39293</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-body">
                            <div className="deposit-wrapper">
                                <div className="deposit-item">
                                    <h3>Choose a bank to withdraw <br className="mobile" /> money into</h3>
                                    <SelectDropdown
                                        options={selectBanksOptions}
                                        onSelect={onSelectBanksandWallet}
                                        placeholder="Select a bank"
                                        placeholderIcon={bankIcon}
                                        className="wallet-dropdown"
                                        showSpecificItem={2} // This will pre-select specific Wallet by passing index
                                    />
                                </div>
                                <div className="deposit-item">
                                    <h3>Amount</h3>
                                    <div className="form">
                                        <div className="form-group">
                                            <div className="amount-wrapper">
                                                <div className="icon"><p className="p w-600">$</p></div>
                                                <input type="text" className="form-control black-placeholder" placeholder="Enter Amount in USD" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-footer">
                            <ul className="btn-list">
                                <li><a href="#" className="btn-style">Submit</a></li>
                            </ul>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
            {/* Assets Withdraw Funds Modal End */}


            {/* Mobile Popups End */}

        </div >
    )
}

export default HomePage
